<!--
 * @Description: 网盘管理-学校网盘 修改
 * @Author: PF
 * @Date: 2024-06-04 14:43:47
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:29:43
-->
<template>
  <div>
    <el-dialog class="w500 h600" :model-value="openYiDong" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon"><Edit /></el-icon>
          <span class="header-title">文件移动</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openYiDong', emits, false)">
            <el-icon><Close /></el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="101px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="文件(夹)名称" prop="id" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              {{ row.wjmc }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="目标文件夹">
              {{ row.mbwjj }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="移动到" prop="fwjid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-tree
                class="mt5"
                :data="treeData"
                :props="{children: 'children',label: 'value'}"
                @node-click="handleNodeClick"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openYiDong', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'

const props = defineProps({ openYiDong: { type: Boolean, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openYiDong', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})


const handleNodeClick = (data) => {
  ruleForm.value.fwjid = data.key
  row.value.mbwjj = data.value
}

const row = ref()
const treeData = ref([])

watch(
  () => props.openYiDong,
  () => {
    if (props.openYiDong) {
      ruleForm.value.id = props.row.id
      row.value.wjmc = props.row.wjmc
      ruleForm.value.wplx = props.row.wplx
      loadSelect({
        url: '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli/wangpanwenjiantree',
        data: treeData,
        parms: {
          wplx: props.row.wplx // 网盘类型:0-学校，1-个人网盘，2-部门网盘
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/bangong/wangpanguanli/wangpanwenjianguanli/movefolder',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openYiDong', emits, true)
    }
  })
}
</script>
